import { argbFromHex } from '@material/material-color-utilities'

import { BrandKitsAPI } from '@makyoapp/makyo-sdk'
import { DEFAULT_MATERIAL_TYPOGRAPHY } from '@makyoapp/makyo-tw-ui'

import { DEFAULT_EXTENDED_COLORS, MtTypographyKey } from '@/shared/brand-kit'

export interface CreateBrandKitPayload {
  orgId: string
  name: string
  logo?: File | null
  logoExt?: string
  color: string
}

/**
 * POST: Create new brand kit
 */
export function createBrandKit({ orgId, name, logo = null, logoExt = '', color }: CreateBrandKitPayload) {
  return BrandKitsAPI.ReqAdd({
    _OrgID: orgId,
    _Name: name,
    _Logo: logo,
    _LogoFileExt: logoExt,
    _Colors: [
      {
        _Value: argbFromHex(color),
        _Name: 'Default',
        _IsDefault: true,
        _CustomColors: DEFAULT_EXTENDED_COLORS,
      },
    ],
    _FontsFamily: Object.fromEntries(
      Object.keys(DEFAULT_MATERIAL_TYPOGRAPHY).map((k) => {
        return [k, JSON.stringify(DEFAULT_MATERIAL_TYPOGRAPHY[k as MtTypographyKey])]
      })
    ),
  })
}
